import axios from '@/components/api/axios';

async function getPlan(optionContractType) {
  let data = {
    optionContractType: optionContractType
  }
  const res = await axios.axiosGet('/api/optionContracts/getPlan', data);
  return res;
}

async function apply(creditCardId, optionContractId) {
  let data = {
    creditCardId: creditCardId,
    optionContractId: optionContractId
  }
  const res = await axios.axiosPost('/api/optionContracts/apply', data);
  return res;
}

async function getThumbnailList(contentsType) {
  let data = {
    contentsType: contentsType
  }
  const res = await axios.axiosGet('/api/fanClub/contents/getThumbnailList', data);
  return res;
}

async function getDetail(id) {
  let data = {
    id: id
  }
  const res = await axios.axiosGet('/api/fanClub/contents/getDetail', data);
  return res;
}

export default {
  getPlan,
  apply,
  getThumbnailList,
  getDetail
}



// WEBPACK FOOTER //
// ./src/components/api/fanClub.js